import type { SxProps, Theme } from '../../themes/themes';

export const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    box: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'block',
      },
      gap: theme.spacing(5),
    },
    icon: {
      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(7),
      },
    },
    text: {
      '&:hover': {
        textDecoration: 'underline',
      },
      display: 'flex',
      alignItems: 'center',
      flexGrow: 1,
      justifyContent: 'space-between',
      [theme.breakpoints.up('md')]: {
        justifyContent: 'flex-start',
      },
    },
    arrowIcon: {
      marginLeft: theme.spacing(4),
    },
    description: {
      display: 'none',
      color: theme.palette.grey['900'],

      [theme.breakpoints.up('md')]: {
        display: 'block',
        paddingTop: theme.spacing(5),
      },
    },
  };
};
